import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-fire-line"></i>
            <span>热门排行</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            人气排行 · 大家都在看什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            实时热度排行，发现当下最受欢迎的漫画作品
          </p>
        </div>

        <div className="bg-background-100 rounded-xl overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-200/50 transition-colors ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">{item.title}</h3>
                  {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                </div>
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
                  <span className="text-primary-500 font-medium">{item.category}</span>
                  <span>{item.episodes}</span>
                </div>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="text-sm font-bold text-accent-500 whitespace-nowrap">{item.heat}</div>
                <div className="text-xs text-foreground-400">热度</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}